import { registerPlugin } from '@capacitor/core';
import { isError } from './utils';
const DeviceAuthenticity = registerPlugin('DeviceAuthenticity', {
    web: () => import('./web').then(m => new m.DeviceAuthenticityWeb()),
});
export * from './definitions';
export { DeviceAuthenticity, isError, };
//# sourceMappingURL=index.js.map